const smsCode = {
  /**
   * 使用示例：
   *    引入： import smsCode from '@/api/smsCode'
   *    如使用的方法如下：
   *      sendCode(event){
   *        //这里要先把元素对象保存到一个变量中，不要直接使用event.currentTarget作为之后方法的element参数，因为event.currentTarget的值会发生变化
   *        const el = event.currentTarget
   *        let param = smsCode.butResendCountdown(el)  //设置倒计时
   *        post(...).then{
   *          ...
   *        }.catch{
   *          smsCode.butReset(el,param)  //失败后重置元素
   *        }
   *      }
   * 注：
   *    短信发送失败后要调用butReset方法重置元素状态
   */

  /**
   * 发送短信后倒计时n秒后才可以重新操作(but类型使用)
   * @param {*} element 触发发送短信的元素
   * @param {*} time 倒计时时间
   * return reset_param : 短信发送失败后，重置元素状态的所需参数
   */
  butResendCountdown(element, type = 'input', time = 60) {
    let property_key
    switch (type) {
      case 'input':
        property_key = 'value'
        break
      case 'a':
        property_key = 'text'
        break
      default:
        property_key = 'value'
        break
    }
    var num = time
    let old_valueel = element[property_key]
    let old_colorel = element.style.color
    var timer = setInterval(function() {
      num--
      element[property_key] = num + '秒后重新获取'
      element.style.color = ' #ccc'
      element.disabled = ' disabled'
      if (num === 0) {
        element.disabled = ''
        element.style.color = old_colorel
        element[property_key] = old_valueel
        clearInterval(timer)
      }
    }, 1000)
    let reset_param = {
      timer: timer,
      old_valueel: old_valueel,
      old_colorel: old_colorel
    }
    return reset_param
  },

  /**
   * 短信发送失败后重置元素状态 (but类型使用)
   * @param {*} element 触发发送短信的元素
   * @param {*} param 重置元素状态的所需参数
   */
  butReset(element, param, type) {
    let property_key
    switch (type) {
      case 'input':
        property_key = 'value'
        break
      case 'a':
        property_key = 'text'
        break
      default:
        property_key = 'value'
        break
    }
    clearInterval(param.timer)
    element.disabled = ''
    element.style.color = param.old_colorel
    element[property_key] = param.old_valueel
  }
}

export default smsCode



// WEBPACK FOOTER //
// ./src/api/smsCode.js